import { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import * as PainelGeralService from '../../InfoPanel/services';
import { getModel } from '../utils';

const initialScopeListData = {
  categoria: { lista: [], value: [], cache: [] },
  secao: { lista: [], value: [], cache: [] },
};

export const useScopeSelectRequestList = () => {
  const [scopeListData, setScopeListData] = useState(initialScopeListData);
  const [timer, setTimer] = useState(null);

  const { filtrosDataCompetitividade } = useSelector(
    state => ({
      filtrosDataCompetitividade: state.analiseCompetitividadeDataReducer.filtrosDataCompetitividade,
    }),
    shallowEqual,
  );

  const setList = (list, scopeKey) => {
    const newList = list.map(item => ({
      label: item?.key,
      value: item?.key,
      datapoints: item?.datapoints,
    }));

    setScopeListData(prevState => ({
      ...prevState,
      [scopeKey]: {
        ...prevState[scopeKey],
        lista: newList,
      },
    }));
  };

  const getScopeListFilter = (params, scopeKey) => {
    PainelGeralService.getItensFiltros(params).then(data => {
      if (data) {
        setList(data, scopeKey);
      }
    });
  };

  const handleGetScopeList = scopeKey => {
    getScopeListFilter(getModel(filtrosDataCompetitividade, '', scopeKey), scopeKey);
  };

  const handleSearchScopeList = (inputValue, scopeKey) => {
    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      getScopeListFilter(getModel(filtrosDataCompetitividade, inputValue, scopeKey), scopeKey);
    }, 500);

    setTimer(newTimer);
  };

  const handleSelectScopeItem = (scopeKey, value) => {
    setScopeListData(prevState => ({
      ...prevState,
      [scopeKey]: {
        ...prevState[scopeKey],
        value,
      },
    }));
  };

  const handleRestoreScopeItem = (scopeKey, values) => {
    const restoredList = (values || []).map(value => ({ label: value, value }));

    setScopeListData(prevState => ({
      ...prevState,
      [scopeKey]: {
        ...prevState[scopeKey],
        lista: restoredList,
        value: values || [],
      },
    }));
  };

  const handleCleanScopeItem = scopeKey => {
    setScopeListData(prevState => ({
      ...prevState,
      [scopeKey]: {
        ...prevState[scopeKey],
        value: [],
        cache: [],
      },
    }));
  };

  const handleCleanAllScopeSelects = () => setScopeListData(initialScopeListData);

  return {
    scopeListData,
    handlersScopeList: {
      handleGetScopeList,
      handleSearchScopeList,
      handleSelectScopeItem,
      handleRestoreScopeItem,
      handleCleanScopeItem,
      handleCleanAllScopeSelects,
    },
  };
};
